/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserLoginInfoDto } from './userLoginInfoDto';
import { ApplicationInfoDto } from './applicationInfoDto';


export interface GetCurrentLoginInformationOutput { 
    application?: ApplicationInfoDto;
    user?: UserLoginInfoDto;
}

